import script from "./LandingHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingHeader.vue?vue&type=script&lang=ts&setup=true"

import "./LandingHeader.vue?vue&type=style&index=0&id=6ba5690c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba5690c"]])

export default __exports__